// automatically modified by fastlane
const revisionSuffix = 0
const useCodeBundleId = false // automatically set to `false` on each build, to `true` on each hot-updater release

export default {
  revisionSuffix,
  useCodeBundleId,
}
